/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRoadOff = createReactComponent("outline", "road-off", "IconRoadOff", [["path", { "d": "M4 19l3.332 -11.661", "key": "svg-0" }], ["path", { "d": "M16 5l2.806 9.823", "key": "svg-1" }], ["path", { "d": "M12 8v-2", "key": "svg-2" }], ["path", { "d": "M12 13v-1", "key": "svg-3" }], ["path", { "d": "M12 18v-2", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

export { IconRoadOff as default };
//# sourceMappingURL=IconRoadOff.mjs.map
